import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2, Output, EventEmitter, NgZone, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CredentialResponse } from 'google-one-tap';

import { environment } from '../../environments/environment';

@Component({
  selector: 'app-google-button',
  templateUrl: './google-button.component.html',
  styleUrls: ['./google-button.component.scss'],
  standalone: false
})
export class GoogleButtonComponent implements OnInit, OnChanges, OnDestroy {
  @Input() locale: string;
  @Input() signupButton = false;
  @Output() googleSignIn: EventEmitter<string> = new EventEmitter<string>();

  private googleScript: HTMLScriptElement;

  constructor(
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.googleScript = this.renderer2.createElement('script');
    this.googleScript.type = 'text/javascript';
    this.googleScript.src = 'https://accounts.google.com/gsi/client';
    this.googleScript.async = true;
    this.googleScript.defer = true;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.renderer2.appendChild(this.document.head, this.googleScript);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.onGoogleLibraryLoad = () => {
      this.loaded();
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (changes && !changes['locale'].firstChange) {
      if (changes['locale'].previousValue !== changes['locale'].currentValue) {
        window.location.reload();
      }
    }
  }

  loaded(): void {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    google.accounts.id.initialize({
      auto_select: false,
      callback: this.handleGoogleResponse.bind(this),
      cancel_on_tap_outside: true,
      client_id: environment.googleApiAppId,
      ux_mode: 'popup'
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    google.accounts.id.renderButton(document.getElementById('google-btn'), {
      theme: 'outline',
      size: 'large',
      text: `${this.signupButton ? 'signup_with' : 'signin_with'}`,
      locale: this.locale
    });
  }

  handleGoogleResponse(response: CredentialResponse) {
    this.ngZone.run(() => {
      this.googleSignIn.emit(response.credential);
    });
  }

  ngOnDestroy() {
    this.renderer2.removeChild((this.document as Document).head, this.googleScript);
  }
}
